import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ExpensesModelService} from '../../../Models/Finances/Expenses/expenses-model.service';
import {ExpensesFilters} from '../../../../Models/Finances/Expenses/expenses-filters.model';
import {GeneralExpenseStore} from '../../../../Models/Finances/Expenses/general-expense-store.model';
import {PersonalExpenseStore} from '../../../../Models/Finances/Expenses/personal-expense-store.model';
import {forkJoin} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpensesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ExpensesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los gastos
   *
   */
  public getExpenses(params: ExpensesFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      const generalExpensesApi = this.httpCall('getResumenGastosGeneralesForApp', params);
      const personalExpensesApi = this.httpCall('getResumenGastosPersonalForApp', params);

      return forkJoin([generalExpensesApi, personalExpensesApi]).subscribe({
        next: ([responseGeneralExpenses, responsePersonalExpenses]) => {

          const combinedResponse = {
            duracion: responseGeneralExpenses.duracion,
            mensaje: `${responseGeneralExpenses.mensaje} y ${responsePersonalExpenses.mensaje}`,
            status: responseGeneralExpenses.status === responsePersonalExpenses.status ? responseGeneralExpenses.status : 0,
            data: {
              general: responseGeneralExpenses.data,
              personal: responsePersonalExpenses.data,
            }
          };

          if (save) {
            this.model.save(combinedResponse.data);
          }

          resolve(combinedResponse);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Marcar/Desmarcar el gasto como pagado
   *
   */
  public setPaidExpense(params: {id: number}): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setGastoPagado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Marcar/Desmarcar todos los gastos como pagados
   *
   */
  public setPaidAllExpenses(params: {ids: number[]}): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setGastosPagado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar gasto general
   *
   */
  public setGeneralExpense(params: GeneralExpenseStore): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setGastoGeneral', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar gasto personal
   *
   */
  public setPersonalExpense(params: PersonalExpenseStore): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setGastoPersonal', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar gasto general
   *
   */
  public deleteGeneralExpense(params: {id: number, cascade: boolean}): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteGastoGeneral', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
